"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var stream_1 = require('stream');
var PointerStream = (function (_super) {
    __extends(PointerStream, _super);
    function PointerStream(opts) {
        var _this = this;
        _super.call(this, Object.assign({ objectMode: true }, opts));
        this.tick = function () {
            if (!_this.shell.pointerLock)
                return;
            var dx = _this.shell.prevMouseX - _this.shell.mouseX;
            var dy = _this.shell.prevMouseY - _this.shell.mouseY;
            var dt = Date.now() - _this.shell.startTime;
            _this.push({ dx: dx, dy: dy, dt: dt });
        };
        this.shell = opts.shell;
        if (!this.shell)
            throw new Error('PointerStream requires shell option set to game-shell instance');
        this.enable();
    }
    PointerStream.prototype.enable = function () {
        this.shell.on('tick', this.tick);
    };
    ;
    PointerStream.prototype.disable = function () {
        this.shell.removeListener('tick', this.tick);
    };
    ;
    PointerStream.prototype._read = function () {
        // must implement, but don't add any updates on-demand
    };
    ;
    return PointerStream;
}(stream_1.Readable));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PointerStream;
//# sourceMappingURL=PointerStream.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/controls/PointerStream.js
 ** module id = 932
 ** module chunks = 0
 **/